// extracted by mini-css-extract-plugin
export var externalLink = "_ct-0";
export var internalLinkLabel = "_ct-1";